import { ComposedChart, Area, Line, LabelList, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import InfoTip from "./InfoTip";
import { VerticalCursor, TipBox } from "./FlowChart";
import { money, dpct, k, niceMax, ticksTo, COLORS } from "./metricsMath";

const BalTip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const r = payload[0].payload;
  const lines = [[COLORS.bal, "Saldo al cierre", money(r.saldo)]];
  if (r.crec != null) lines.push([null, "Cambio vs mes anterior", dpct(r.crec), r.crec > 0 ? "text-[#00873D]" : r.crec < 0 ? "text-[#E0000F]" : "text-zinc-500"]);
  return <TipBox testid="balance-tooltip" title={r.mesLargo} lines={lines} />;
};

// Etiqueta doble sobre cada punto: % de cambio arriba y el saldo abajo.
const PointLabel = ({ x, y, index, rows }) => {
  const r = rows[index];
  if (!r || r.saldo == null) return null;
  return (
    <g>
      <text x={x} y={y - 12} textAnchor="middle" fontSize={11} fontWeight={700} fill="#18181b">{k(r.saldo)}</text>
      {r.crec != null && <text x={x} y={y - 26} textAnchor="middle" fontSize={11} fontWeight={700} fill={r.crec > 0 ? COLORS.in : r.crec < 0 ? COLORS.out : "#71717a"} data-testid={`growth-label-${r.month}`}>{dpct(r.crec)}</text>}
    </g>
  );
};

export default function BalanceChart({ rows, fx }) {
  const top = niceMax(Math.max(0, ...rows.map((r) => r.saldo || 0)));
  return (
    <section className="border border-zinc-200 bg-white rounded-lg p-5 flex flex-col gap-2 min-w-0" data-testid="balance-section">
      <h3 className="font-heading font-bold text-base m-0 inline-flex items-center gap-1.5">Saldo al cierre de cada mes <InfoTip k="balance" /></h3>
      <p className="text-xs text-zinc-500 m-0 leading-relaxed">Total en bancos al último día del mes (TC {Number(fx || 0).toFixed(2)}), con su cambio contra el mes anterior <InfoTip k="growth" />.</p>
      <div className="h-[280px]" data-testid="balance-chart">
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart data={rows} margin={{ top: 36, right: 24, left: 0, bottom: 0 }}>
            <defs>
              <linearGradient id="balFill" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor={COLORS.bal} stopOpacity={0.26} />
                <stop offset="100%" stopColor={COLORS.bal} stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0eeea" vertical={false} />
            <XAxis dataKey="mes" interval={0} tick={{ fontSize: 11, fill: "#71717a" }} axisLine={false} tickLine={false} padding={{ left: 24, right: 24 }} />
            <YAxis tickFormatter={k} tick={{ fontSize: 11, fill: "#71717a" }} axisLine={false} tickLine={false} width={44} domain={[0, top]} ticks={ticksTo(top)} />
            <Tooltip content={<BalTip />} cursor={<VerticalCursor />} />
            <Area type="monotone" dataKey="saldo" stroke="none" fill="url(#balFill)" connectNulls={false} isAnimationActive={false} />
            <Line type="monotone" dataKey="saldo" stroke={COLORS.bal} strokeWidth={2} dot={{ r: 4, fill: COLORS.bal, stroke: "#fff", strokeWidth: 2 }} activeDot={{ r: 5 }} connectNulls={false} isAnimationActive={false}>
              <LabelList dataKey="saldo" content={<PointLabel rows={rows} />} />
            </Line>
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </section>
  );
}
